import React from 'react';

const Acceptance = ({ field, form: { touched, errors }, ...props }) => {
  const { className, tooltip, children, required } = props;

  return (
    <div className={`mb-2  ${className}`}>
      <label className='flex items-start'>
        {required && <span className='text-red-500 ml-1 mr-2'>*</span>}
        <input type='checkbox' {...field} className='mr-2 leading-tight' />
        {children && (
          <span className=' text-gray-700 text-sm'>
            {children}
            {tooltip && (
              <div className='tooltip'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  stroke='currentColor'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  className='feather feather-help-circle stroke-current w-4 h-4 ml-1'
                >
                  <circle cx='12' cy='12' r='10'></circle>
                  <path d='M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3'></path>
                  <line x1='12' y1='17' x2='12' y2='17'></line>
                </svg>
                <span className='tooltiptext tooltip-top text-xs w-64'>
                  {tooltip}
                </span>
              </div>
            )}
          </span>
        )}
      </label>
      {touched[field.name] && errors[field.name] && (
        <div className='text-xs text-red-500'>{errors[field.name]}</div>
      )}
    </div>
  );
};

export default Acceptance;
